import actionCreators from './action-creators';

export const initialState = {
  slo: {
    /* NOTE:
     * In terms of the API:
     * isDraft=false means filter out all SLOs which are drafts
     * isDraft=true means filter out all SLOs which are not drafts (no use case for this presently)
     * No isDraft request parameter means don’t filter.
     */
    showDrafts: false,
    hasBreachStatusOnly: false,
    hasQualityIssuesOnly: false,
  },
};

type State = typeof initialState;
type Action = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'TOGGLE_SLO_SHOWDRAFTS':
      return { ...state, slo: { ...state.slo, showDrafts: !state.slo.showDrafts } };
    case 'SET_SLO_SHOWDRAFTS':
      return { ...state, slo: { ...state.slo, showDrafts: action.payload } };
    case 'TOGGLE_SLO_HAS_BREACHING_ONLY':
      return {
        ...state,
        slo: { ...state.slo, hasBreachStatusOnly: !state.slo.hasBreachStatusOnly },
      };
    case 'SET_SLO_HAS_BREACHING_ONLY':
      return { ...state, slo: { ...state.slo, hasBreachStatusOnly: action.payload } };
    case 'TOGGLE_SLO_HAS_QUALITY_ISSUES_ONLY':
      return {
        ...state,
        slo: { ...state.slo, hasQualityIssuesOnly: !state.slo.hasQualityIssuesOnly },
      };
    case 'SET_SLO_HAS_QUALITY_ISSUES_ONLY':
      return { ...state, slo: { ...state.slo, hasQualityIssuesOnly: action.payload } };
    default:
      return state;
  }
}
